import React from 'react'
import { ReactComponent as Alert } from '../../../../assets/icons/alert-circle.svg'
import styled from 'styled-components'
import { bool } from 'prop-types'
import Button from '@taglivros/oef_componentes/build/components/button'
import { ROUTE_BASEPATH, URLS } from '../../../../constants'
import { URLS_APP } from '../../../../config'
import { navigate } from '@reach/router'

const RenovarAgoraWrapper = styled.div`
  background: #fef8fa;
  padding: 18px 18px 18px 33px;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  svg path {
    stroke: #b72133;
  }

  .message-span {
    font-family: "Noto Sans Display", sans-serif;
    font-style: normal;
    font-size: 16px;
    line-height: 24px;
    color: #b72133;
    b {
      font-weight: 600;
    }
  }
  .normal-span {
    font-size: 12px;
    line-height: 16px;
    font-family: "Noto Sans Display", sans-serif;
    padding-top: 10px;
  }
  .svg-spans {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 19px;
  }
  button {
    width: 96%;
    margin-top: 20px;
    &:after {
      background-color: #b72133 !important;
    }
    &:before {
      background-color: #971c2a !important;
    }
  }
  .data {
    display: flex;
    align-items: center;
  }
`

export const RegularizarPagamento = ( { isCuradoria } ) => {
  return (
    <RenovarAgoraWrapper id="regularizar-pagamento">
      <div className="svg-spans">
        <div>
          <Alert />
        </div>

        <span className="message-span">
          <b>Ocorreu falha na cobrança da renovação da sua assinatura.</b>

          {` Clique no botão abaixo para regularizar sua situação.`}
        </span>
      </div>

      <div>
        <Button
          onClick={ () => navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${
            isCuradoria ? 'curadoria' : 'ineditos'
          }/${URLS.PLANO}/${URLS.RENOVAR_PLANO_ENTREGA}/#regularizar` ) }
        >
          Regularizar pagamento
        </Button>
      </div>
    </RenovarAgoraWrapper>
  )
}

RegularizarPagamento.propTypes = {
  'isCuradoria': bool.isRequired,
}
